import { ClickAwayListener, Typography, Modal, Box } from "@mui/material";
import App from "../mobile/App";

function AppScreenDesktop() {
  return (
    <App>
      <Modal
        sx={{
          display: { xs: "block" },
        }}
        open={true}
        onClose={() => {}}
        // hideBackdrop={true}
        slotProps={{
          root: {},
          backdrop: {
            sx: {
              backgroundColor: "rgba(0, 0, 0, 0.2)",
            },
          },
        }}
      >
        {/*<ClickAwayListener onClickAway={handleClose}>*/}
        <Box
          sx={{
            width: "400px",
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            backgroundColor: "#fff",
            padding: "30px",
            borderRadius: "20px",
            "&:focus": {
              outline: "none",
            },
          }}
        >
          <Typography fontSize={"38px"}>
            Для правильной работы откройте приложение на мобильном устройстве
          </Typography>
        </Box>
      </Modal>
    </App>
  );
}

export default AppScreenDesktop;
